export default __webpack_public_path__ + "static/media/backspace.3d88489b.svg";